export default () => {
  const formResetBtns = document.querySelectorAll('input[type="reset"]');
  for (let index = 0; index < formResetBtns.length; index++) {
    const btn = formResetBtns[index];
    const form = btn.form;
    btn.addEventListener("click", () => {
      const formInputs = form.querySelectorAll(
        "input:not([type='reset']), select, textarea"
      );
      let inputsWithVals = 0;
      for (let index = 0; index < formInputs.length; index++) {
        const formInput = formInputs[index];
        if (formInput.value) {
          formInput.value = "";
          inputsWithVals++;
        }
      }

      if (inputsWithVals) {
        form.submit();
      }
    });
  }
};
